/**
 * Config module: types, replaceable ConfigService, and default getConfig().
 * Default: config is loaded from config.json via initConfigFromJson() at app startup.
 */

import { setConfigService } from "./config-service.holder";
import { loadConfigFromJson } from "./json-config.service";

export type { Config, ConfigFeatures, ConfigService } from "./config.types";
export {
	getConfig,
	getConfigService,
	setConfigService,
} from "./config-service.holder";
export { EnvConfigService } from "./env-config.service";
export {
	JsonConfigService,
	loadConfigFromJson,
} from "./json-config.service";
export type { ConfigJson } from "./config-json.types";

/**
 * Loads config from config.json and sets it as the active config service.
 * Call before rendering the app so getConfig() uses config.json.
 *
 * @param url - Config URL (default: "/config.json")
 */
export async function initConfigFromJson(url = "/config.json"): Promise<void> {
	const service = await loadConfigFromJson(url);
	setConfigService(service);
}
